import { generateNativeMessageSender } from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import { logError } from '~/utilities/loggers';

export default function getSourcedSendMessageToNative<Event>(source: string) {
  return generateNativeMessageSender<Event>({
    logError,
    source,
    verboseLogs: isNonProd
  });
}
